(function () {
  const STORAGE_KEY = 'superga_recently_viewed';
  const STORAGE_LIMIT = 20;
  const SECTION_ID = 'product-card-ajax';
  const DEFAULT_EXCLUDED_HANDLES = ['gift-wrapping'];

  function normalizeHandle(handle) {
    return String(handle || '').trim().toLowerCase();
  }

  function readHandles() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  function writeHandles(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      /* ignore quota errors */
    }
  }

  function isExcluded(handle, extraExcluded) {
    const normalized = normalizeHandle(handle);
    if (!normalized) return true;

    const excluded = DEFAULT_EXCLUDED_HANDLES.concat(extraExcluded || []).map(normalizeHandle);
    return excluded.includes(normalized);
  }

  function record(handle, extraExcluded) {
    const normalized = normalizeHandle(handle);
    if (!normalized || isExcluded(normalized, extraExcluded)) return;

    const handles = readHandles().filter((item) => normalizeHandle(item) !== normalized);
    handles.unshift(normalized);
    writeHandles(handles.slice(0, STORAGE_LIMIT));
  }

  function getHandles({ limit = 6, excludeHandle = '', excludeHandles = [] } = {}) {
    const excluded = DEFAULT_EXCLUDED_HANDLES.concat(excludeHandles);
    if (excludeHandle) excluded.push(excludeHandle);

    return readHandles()
      .filter((handle) => !isExcluded(handle, excluded))
      .slice(0, limit);
  }

  function getStoreRoot() {
    if (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  async function fetchProductCard(handle) {
    const root = getStoreRoot();
    const response = await fetch(
      `${root}products/${encodeURIComponent(handle)}?sections=${SECTION_ID}`
    );
    if (!response.ok) return '';

    const data = await response.json();
    return data[SECTION_ID] || '';
  }

  function rehydrateScripts(container) {
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.rehydrateInlineScripts) {
      FacetFiltersForm.rehydrateInlineScripts(container);
      return;
    }

    container.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  async function render(container, options = {}) {
    if (!container) return { count: 0 };

    const {
      limit = 6,
      excludeHandle = '',
      excludeHandles = [],
      force = false,
    } = options;

    if (container.dataset.recentlyViewLoaded === 'true' && !force) {
      return { count: container.querySelectorAll('.product-card-2026').length };
    }

    const handles = getHandles({ limit, excludeHandle, excludeHandles });
    if (!handles.length) {
      container.innerHTML = '';
      container.dataset.recentlyViewLoaded = 'true';
      return { count: 0 };
    }

    const cards = await Promise.all(handles.map((handle) => fetchProductCard(handle)));
    const markup = cards.filter(Boolean).join('');

    if (!markup) {
      container.innerHTML = '';
      container.dataset.recentlyViewLoaded = 'true';
      return { count: 0 };
    }

    container.innerHTML = `
      <div class="rp__products-swiper">
        <div class="rp__products-track">${markup}</div>
      </div>
    `;

    rehydrateScripts(container);
    container.dataset.recentlyViewLoaded = 'true';

    return { count: container.querySelectorAll('.product-card-2026').length };
  }

  window.ProductRecentlyViewed = {
    record,
    getHandles,
    render,
  };
})();
